// extracted by mini-css-extract-plugin
export default {"formatBar":"formatBar---hEoWk","content":"content---js2EZ"};